<template>
	
	<div>
		<a @click="$router.go(-1)">regresar</a>
		<br>
		<br>
		<h2>Propiedad {{this.id}}</h2>
		<div id="propi">
			<div name='propiedad-ver' v-if='propiedadSola !=null'>
				<table id='todos' align="center" v-for="propiedades in propiedadSola" >
					<tr>
					<td>nombreCompleto:</td>
					<td>{{propiedades.nombreCompleto}}</td>
					</tr>
					<tr>
					<td>familia:</td>
					<td>{{propiedades.familia}}</td>
					</tr>
					<tr>
					<td>subfamilia:</td>
					<td>{{propiedades.subfamilia}}</td>
					</tr>
					<tr>
					<td>tipo:</td>
					<td>{{propiedades.tipo}}</td>
					</tr>
					<tr>
					<td>claveCatastral:</td>
					<td>{{propiedades.claveCatastral}}</td>
					</tr>
					<tr>
					<td>pais:</td>
					<td>{{propiedades.pais}}</td>
					</tr>
					<tr>
					<td>dirCalle:</td>
					<td>{{propiedades.dirCalle}}</td>
					</tr>
					<tr>
					<td>dirNumero:</td>
					<td>{{propiedades.dirNumero}}</td>
					</tr>
					<tr>
					<td>dirInterior:</td>
					<td>{{propiedades.dirInterior}}</td>
					</tr>
					<tr>
					<td>dirCiudad:</td>
					<td>{{propiedades.dirCiudad}}</td>
					</tr>
					<tr>
					<td>dirEstado:</td>
					<td>{{propiedades.dirEstado}}</td>
					</tr>
					<tr>
					<td>dirCodigo:</td>
					<td>{{propiedades.dirCodigo}}</td>
					</tr>
					<tr>
					<td>metrosCuadrados:</td>
					<td>{{propiedades.metrosCuadrados}}</td>
					</tr>
					<tr>
					<td>status:</td>
					<td><b>{{propiedades.status}}</b></td>
					</tr>
				</table>
			</div>
		<span v-else>Cargando propiedad</span>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default{
		name:'propiedad-ver',
	
		mounted(){
			this.entrar();
		},
		props:['vector'],
		data(){
			return{
				id: null,
				propiedadSola: null	
			}
		},
		methods:{
			entrar(){
				// checa si tiene autorizacion
		  		if(!this.vector.includes('MASTERGGUV')){
			  		if(!this.vector.includes('Propiedades Ver detalle')){
			  			document.getElementById('propi').hidden = true;
			  			alert('Seccion no autorizada');
			  			return;
			  		}
			  	}
				this.id=this.$route.params.id;
				axios.get('https://www.directodo.com/Rentus/accesosdb/leeUnaPropiedad.php?id='+this.id)
  		         .then((respue) => {
  		     		this.propiedadSola=respue.data;
  		     		console.log(respue.data);
  			 	 });
			}
		}
	}
</script>

	table #todos {
	    font-family: arial, sans-serif;
	    border-collapse: collapse;
	    width: 100%;
	}

	tr, th {
	    border: 1px solid #dddddd;
	    text-align: left;
	    padding: 8px;
	}

	tr:nth-child(even) {
	    background-color: #dddddd;
	}

</style>


// WEBPACK FOOTER //
// src/Propiedad-ver.vue